import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MagazinesRoutingModule } from './magazines-routing.module';

import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';

import { MagazinesComponent } from './components/magazines/magazines.component';
import { MagazinesDetailsComponent } from './components/magazines-details/magazines-details.component';

// Internamente les decimos revistas, en la web les decimos artículos

@NgModule({
  declarations: [
    MagazinesComponent,
    MagazinesDetailsComponent
  ],
  imports: [
    CommonModule,
    MagazinesRoutingModule,
    MaterialModule,
    SharedModule
  ]
})
export class MagazinesModule { }
